<div *ngIf="!loaded; else content" class="loading-container">
   <mat-spinner [diameter]="24"></mat-spinner>
</div>

<ng-template #content>
  {{ value }}
</ng-template>

